module.exports = __webpack_public_path__ + "img/fire.acf6ce3a.svg";